import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from 'vue-property-decorator';
import { MapData, MapDataAddress } from '@/types/map-data';

@Component({
})
export class ContactListAbstract extends Vue {
    @Prop({default: false}) loading!: boolean
    @Prop({default: []}) mapDataArr!: MapData[]
    noResultsText = 'Нет результатов, удовлетворяющих параметрам поиска.'
    @Emit() selectMarker(mapData: MapData) {
        return mapData
    }
    get noDataText() {
        return this.loading ? 'Идет поиск...' : this.noResultsText
    }
}